import type { FaireProductEntity } from "../../entity_types/product";

export const p_gey49hcgug: FaireProductEntity = {
  token: "p_gey49hcgug",
  type: "product",
  name: "Quilted Blanket, Patchwork",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/a348550932a114b89de69d51007e92419bea2fae23c1a1a66a8b1876eb64fe42.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6dcdc7cb049c5c336f168e4d836d3edfe88efebbf7af607905c3d30b9546772f.jpeg",
    "https://cdn.faire.com/fastly/4bbec7bd0c6b9c5ac760dfc79c9ff5d49633730533d19d508fb479567e84e3fc.jpeg",
    "https://cdn.faire.com/fastly/c04cec18940f7e3c9914b953231e357a0bfc00c13548e07db9a4ca8d8c550afb.jpeg"
  ],
  priceDollars: 22,
  description: "This is truly something to write home about! This quilted blanket is machine washable and features a cheerful, colorful design that instantly brightens any room. Cozy enough for couch naps and cute enough for display, it’s a feel-good essential for every home.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• Soft quilted blanket with vibrant, uplifting artwork\n• Machine washable for easy care\n• Perfect for lounging, layering, or gifting\n• Lightweight yet cozy for year-round use\n• Designed in Bando’s signature bright and joyful style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫\n\n• Gift shops and home décor boutiques\n• Lifestyle and bedding retailers\n• Homebodies, students, and cozy enthusiasts\n• Wholesale buyers seeking fun, colorful home textiles",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:40.646Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
